import { render, staticRenderFns } from "./ThirdForm.vue?vue&type=template&id=7fba801e&scoped=true"
import script from "./ThirdForm.vue?vue&type=script&lang=js"
export * from "./ThirdForm.vue?vue&type=script&lang=js"
import style0 from "./ThirdForm.vue?vue&type=style&index=0&id=7fba801e&prod&lang=scss&scoped=true"
import style1 from "./ThirdForm.vue?vue&type=style&index=1&id=7fba801e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba801e",
  null
  
)

export default component.exports